// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import './assets/style.css'
import axios from 'axios'


Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.prototype.appSet = {
  appid:'5f0eae155aae7',
  appkey:'5f0eae155aaed'
};
/* eslint-disable no-new */
import {Menu, Icon, Layout, LocaleProvider, Input, Dropdown, Badge, Divider, Row, DatePicker, Breadcrumb, Button, Select, Table, Form, Calendar, Modal, Checkbox, Tooltip, Tabs, Drawer, Collapse, Descriptions, Timeline,message, Upload, Spin, Progress, Radio, Popover, Pagination, Slider, Cascader, Avatar, Empty} from 'ant-design-vue';
import { Card } from 'ant-design-vue';
import { Col } from 'ant-design-vue';
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Layout)
Vue.use(LocaleProvider)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(Badge)
Vue.use(Divider)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Breadcrumb)
Vue.use(Dropdown)
Vue.use(Button)
Vue.use(Select)
Vue.use(Table)
Vue.use(Form)
Vue.use(Calendar)
Vue.use(Modal)
Vue.use(Checkbox)
Vue.use(Tooltip)
Vue.use(DatePicker)
Vue.use(Tabs)
Vue.use(Drawer)
Vue.use(Collapse)
Vue.use(Divider)
Vue.use(Descriptions)
Vue.use(Timeline)
Vue.use(Upload)
Vue.use(Spin)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(Slider)
Vue.use(Cascader)
Vue.use(Avatar)
Vue.use(Empty)
Vue.prototype.$message=message

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js